import { io } from 'socket.io-client'

const SOCKET_URL = process.env.VUE_APP_SOCKET_URL
  || process.env.VUE_APP_URL_ECHO
  || 'http://localhost:3000'

const SOCKET_CLIENT_TOKEN = process.env.VUE_APP_SOCKET_CLIENT_TOKEN

const options = {
  transports: ['websocket'],
}

if (SOCKET_CLIENT_TOKEN) {
  options.auth = {
    token: SOCKET_CLIENT_TOKEN,
  }
}

const socket = io(SOCKET_URL, options)

export default socket
